import { baseSplitApi } from "../baseApi";

const versionDetailPath = '/changelog/latest'

export const versionDetailApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        getVersionDetail: build.query({
            query: () => {
                return {
                    url: versionDetailPath,
                    method: 'GET',
                }
            }
        })
    }),
    overrideExisting: false,
}
)

export const { useGetVersionDetailQuery } = versionDetailApi